import { createSessionPrewarm } from '@gokrew/ui/auth';
import { tokenManager } from './index';

/**
 * Same conditions `AuthContext.restoreSession` checks before it refreshes: a
 * mock-login tab restores from its own token, and no `sessionId` means there is
 * nothing to restore.
 */
export const sessionPrewarm = createSessionPrewarm({
  tokenManager,
  hasSession: () =>
    !sessionStorage.getItem('frontend_mock_token') &&
    !!localStorage.getItem('sessionId'),
});
